import request from '../../utils/request'
//各種聲明：relatedByBuy(購買聲明)、relatedByCulture（隐私声明）、relatedByInterests（获取会员权益）、
// relatedByIntro（获取关于我们）、relatedByMemCulture（获取个资及隐私权声明）
export function getAboutInfo(type) {
  return request({
    url: `/tsmgzAbout/${type}`,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/assets/api/common.js